import FormSCSS from '../../assets/scss/Form.module.scss'
import AppSCSS from '../../assets/scss/App.module.scss'
import { useContext, useEffect, useState } from 'react';
import PageContext from 'global_state/context/PageContext';

import content from 'languages/DateInput.json'

function DateInput(props) {

    const { page, dispatchPage } = useContext(PageContext)
    const lang = page.settings.language
    let date_now = new Date()

    const [date_value, setDateValue] = useState('')

    const isValidDate = () => {
        // console.log(date_value);
        let date = new Date(date_value).toString()
        

        if (date == 'Invalid Date') {
            // console.log('invlaid date'.toUpperCase());
            // console.log(date);
            
            return false
        }

        // console.log('valid date'.toUpperCase());
        // console.log(date);
        return true

        // return date instanceof Date && !isNaN(date);

    }
    const handleChange = (value, part) => {
        // console.log("handleChange");
        // console.log(value, part);
            
        /** incorect formating handling */
        if (value == null || value == '') {
            // console.log("no number".toUpperCase());
            let parts = date_value.split('-')
            parts[part] = ''
            let new_date = parts.join('-')
            setDateValue(new_date)
            return 
        }

        let new_value = parseInt(value?.match(/\d+/g).join('')) || ''
        
        // console.log(new_value);
        let parts = date_value.split('-')
        parts[part] = value
        let new_date = parts.join('-')
        
        // console.log(new_date);
        setDateValue(new_date)

    }

    const renderValue = (part) => {
        let parts = date_value.split('-')
        return parts[part] || NaN
    }

    useEffect(() => {
        // if (isValidDate() == true) {
            return props.onChange(props.id, date_value)        
        // }
    }, [date_value])

    useEffect(() => {
        setDateValue(props.value)
    }, [props.value])
    
    const renderInput = (part) => {
        let names = ['year', 'month', 'day']
        let placeholders = ['date_year_placeholder', 'date_month_placeholder',  'date_day_placeholder']
        let mins = [1900, 1, 1]
        let maxs = [date_now.getUTCFullYear(), 12, 31]

        return (
            <input 
            placeholder={content[lang][placeholders[part]]}
            id={props.id + names[part]} 
            name={props.name + names[part]} 
            className={[FormSCSS.input, props.className].join(' ')} 
            type="number" 
            min={mins[part]} 
            max={maxs[part]} 
            onChange={e => {
                handleChange(e.target.value, part)
            }}
            onFocus={e => {
                if (!('onFocus' in props)) {
                    return 
                }
                props.onFocus(props.id)
            }}
            value={renderValue(part)} />
        )
        

    }
    return (
        <label id={props.id} className={[FormSCSS.label, FormSCSS.date_input].join(' ')}>
            {renderInput(2)}
            {renderInput(1)}
            {renderInput(0)}
        </label>
    )
}

export default DateInput